import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import pageheader from "../../pageheader";
import draggable from "vuedraggable";

import reservePlanNewService from "../../../api/reservePlanNew.service";

function compareByItemOrder(a, b) {
  return Number(a.itemOrder) > Number(b.itemOrder)
    ? 1
    : Number(b.itemOrder) > Number(a.itemOrder)
    ? -1
    : 0;
}

export default {
  name: "product-catalog",
  components: { pageheader, draggable },
  data() {
    return {
      input: {},
      isSaveLoading: false,
      hideAllCategoryBtn: false,
      catTrue: false,
      depTrue: false,
      grpTrue: false,
      masterItemsLoading: false,
      tasks: [],
      categoryclick: false,
      groupclick: false,
      departmentclick: false,
      categoryNameList: [],
      depNameList: [],
      groupNameList: [],
      masterItems: [],
      parentKey: "",
    };
  },
  async created() {
    this.getStats();
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.input = utils.getInputContent("productcatalog", this.roles);
  },
  methods: {
    checkMove: function (e) {
      return !this.tasks[e.draggedContext.futureIndex].fixed;
    },
    async getStats() {
      try {
        this.parentKey = "";
        this.masterItemsLoading = true;
        this.setActiveLevel(null);
        this.categoryNameList = [];
        this.depNameList = [];
        this.groupNameList = [];
        let statsResponse = await reservePlanNewService.getItemsList();
        if (statsResponse.isSuccess) {
          this.tasks = JSON.parse(JSON.stringify(statsResponse.data));
          this.masterItems = statsResponse.data;
          this.tasks = utils.dedupeByCategoryNbr(
            this.tasks
              .filter((e) => e.defaultCatItemKeyInd)
              .sort(compareByItemOrder)
          );
          this.tasks = this.tasks.map((d, index) => ({
            ...d,
            itemOrder:
              Number(d.itemOrder) == null ? index + 1 : Number(d.itemOrder),
          }));

          this.masterItemsLoading = false;
        } else {
          this.masterItemsLoading = false;
          this.tasks = [];
        }
      } catch (err) {
        this.masterItemsLoading = false;
        console.log(err);
      }
      this.categoryclick = false;
      this.groupclick = false;
      this.departmentclick = false;
    },
    async updateItemOrder() {
      this.isSaveLoading = true;
      let changedArray = this.tasks.map((item, index) => {
        return {
          itemKey: item.itemKey ? item.itemKey : "",
          itemOrder: index + 1,
        };
      });
      changedArray = changedArray.filter(
        (c) => !c.itemKey || (c.itemKey && c.itemKey != this.parentKey)
      );
      try {
        let response = await reservePlanNewService.updateItemOrder(
          changedArray
        );
        if (response.isSuccess) {
          this.isSaveLoading = false;
          this.$toast.success("Item order Updated");
          this.isSaveLoading = false;
          this.updateMasterOrder(changedArray);
        } else {
          this.isSaveLoading = false;
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to update the order" + err);
        this.isSaveLoading = false;
      }
    },
    updateMasterOrder(changedArray) {
      // setting updated order in master items
      for (let c = 0; c < changedArray.length; c++) {
        for (let m = 0; m < this.masterItems.length; m++) {
          if (this.masterItems[m].itemKey == changedArray[c].itemKey) {
            this.masterItems[m].itemOrder = changedArray[c].itemOrder;
            break;
          }
        }
      }
    },
    setParentKeyToStart() {
      this.tasks.forEach((item, i) => {
        if (item.itemKey === this.parentKey) {
          this.tasks[i]["fixed"] = true;
          this.tasks.splice(i, 1);
          this.tasks.unshift(item);
        }
      });
    },
    setActiveLevel(level) {
      this.categoryclick = level === "category";
      this.departmentclick = level === "department";
      this.groupclick = level === "group";
      this.catTrue = level === "category";
      this.depTrue = level === "department";
      this.grpTrue = level === "group";
    },
    // test methods

    categoryClick(item) {
      this.parentKey = item.itemKey;
      this.tasks = [];
      this.tasks = JSON.parse(
        JSON.stringify(
          utils.dedupeByDepartmentNbr(
            this.masterItems
              .filter(
                (e) =>
                  e.categoryNbr == item.categoryNbr && e.defaultDeptItemKeyInd
              )
              .sort(compareByItemOrder)
          )
        )
      );
      if (this.parentKey) {
        this.setParentKeyToStart();
      }
      this.setActiveLevel("category");
      this.categoryNameList = [];
      this.depNameList = [];
      this.groupNameList = [];
      this.categoryNameList.push(item);
    },
    departmentClick(item) {
      this.parentKey = item.itemKey;
      // Narrow to the department BEFORE deduping by group name -- see the same
      // fix in CreatePlanningSheet.departmentClick.
      this.tasks = JSON.parse(
        JSON.stringify(
          utils.dedupeBy(
            this.masterItems
              .filter((e) => e.departmentNbr == item.departmentNbr)
              .sort(compareByItemOrder),
            (e) => e.itemGroupNm
          )
        )
      );
      if (this.parentKey) {
        this.setParentKeyToStart();
      }
      this.setActiveLevel("department");
      this.depNameList = [];
      this.groupNameList = [];
      this.depNameList.push(item);
    },
    groupClick(item) {
      this.parentKey = item.itemKey;
      this.tasks = [];
      // Scope to the department as well as the group name -- a group name used
      // under two departments would otherwise list both departments' items
      // under either tile. No-op for the groups whose name is unique.
      const groupItems = this.masterItems.filter(
        (e) =>
          e.itemGroupNm == item.itemGroupNm &&
          e.departmentNbr == item.departmentNbr
      );
      this.tasks = JSON.parse(JSON.stringify(groupItems));
      if (this.tasks.length > 1) {
        this.tasks = JSON.parse(
          JSON.stringify(
            [...groupItems].sort(compareByItemOrder)
          )
        );
      }
      if (this.parentKey) {
        this.setParentKeyToStart();
      }
      this.setActiveLevel("group");
      this.groupNameList = [];
      this.groupNameList.push(item);
    },

    async getProjectionItemsList() {
      this.parentKey = "";
      this.setActiveLevel(null);
      this.categoryNameList = [];
      this.depNameList = [];
      this.groupNameList = [];
      this.tasks = [];
      this.hideAllCategoryBtn = false;
      this.tasks = JSON.parse(
        JSON.stringify(
          utils.dedupeByCategoryNbr(
            this.masterItems
              .filter((e) => e.defaultCatItemKeyInd)
              .sort(compareByItemOrder)
          )
        )
      );
    },
    //end
  },
};
